module.exports = __webpack_public_path__ + "img/icon_xiazai_guojia@3x.c74e691d.png";